import { useState } from "react"
import { toast } from "react-toastify"
import { Button } from "@/components/button/Button"
import { exportProject } from "@/fetch/export"

export const ExportProject = ({ projectId }: { projectId: number }) => {
  const [isExporting, setIsExporting] = useState(false)

  const onExport = async () => {
    setIsExporting(true)
    try {
      await exportProject(projectId)
      toast.success("Projekts veiksmīgi eksportēts")
    } catch (error) {
      toast.error("Neizdevās eksportēt projektu")
      console.error(error)
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <Button onClick={onExport} disabled={isExporting} variant="secondary">
      Eksportēt
    </Button>
  )
}
